import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  public clear(): void {
    if (typeof window !== 'undefined') {
      window.localStorage.clear();
    }
  }

  public isLoggedIn(): boolean {
    const isLogin = this.getItem('admin_tokens');
    if (isLogin) {
      return true;
    }
    return false;
  }

  public getItem(key: string) {
    if (typeof window !== 'undefined') {
      return window.localStorage.getItem(key);
    }
    return null;
  }

  public setItem(key: string, value: string) {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(key, value);
    }
    return null;
  }

  public removeItem(key: string) {
    if (typeof window !== 'undefined') {
      window.localStorage.removeItem(key);
    }
    return null;
  }
}
